import React from "react"
import {Tooltip} from "@material-ui/core"

function Truncated({text, size = 15}: {text: string; size?: number}) {
	return (
		<Tooltip title={text} placement="top">
			<span>{truncate(text, size)}</span>
		</Tooltip>
	)
}

function truncate(text: string, max: number, ending = "…") {
	return text.length > max ? text.substr(0, max - ending.length) + ending : text
}

export {Truncated}
